module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("94xkS"))).then(() => parcelRequire('d0iPb'));